import Vue from 'vue'
import Log from '@/views/Log/models/log'

export default class NotificationModel extends Log {
    read
    readAt

    get notificationType() {
        return this._relationships['notificationType']
            ? this._relationships['notificationType']
            : null
    }

    get project() {
        return this._relationships['project'] ? this._relationships['project'] : null
    }

    get actingUser() {
        return this._relationships['actingUser'] ? this._relationships['actingUser'] : null
    }

    get resource() {
        return this._relationships['resource'] ? this._relationships['resource'] : null
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    static async search(query) {
        let res = await Vue.prototype.$vbit.get('notification', 'notifications', query)

        return res.data.map((item) => new NotificationModel(item, res.included))
    }

    async markAsRead() {
        let query = {
            body: {
                data: {
                    id: this._id,
                    type: this._type,
                    attributes: {
                        read: !this.read,
                    },
                },
            },
        }
        let res = await Vue.prototype.$vbit.patch(
            'notification',
            `notifications/${this._id}`,
            query
        )

        return res
    }
}
